import { useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getIsOverviewDataFetching, getIsOverviewDataFetchSuccessful } from '../selectors/overviewSelectors';
import { useEffectOnlyOnce } from './useEffectOnlyOnce';
import { getRows } from '../selectors/aggregatedOverviewDataSelectors';
import { trackTourClick } from '../utils/usageTracker';
// Waits until Overview page data is fetched before surfacing a modal
export default function useOverviewModal(modalAction) {
  const dispatch = useDispatch();
  const isOverviewDataFetching = useSelector(getIsOverviewDataFetching);
  const isOverviewDataFetchSuccessful = useSelector(getIsOverviewDataFetchSuccessful);
  const hasData = useSelector(getRows).size > 0;
  const [isOpen, setIsOpen] = useState(false);
  const handleClose = useCallback(action => {
    setIsOpen(false);
    trackTourClick(action);
  }, [setIsOpen]);

  // Consumers of useOverviewModal should only be opened one time
  // regardless of if their parent component re-renders!
  useEffectOnlyOnce(() => {
    const openModal = async () => {
      await dispatch(modalAction);
      setIsOpen(true);
    };
    openModal().catch(() => {
      /* should be caught in the modalAction */
    });
  }, [isOverviewDataFetching, isOverviewDataFetchSuccessful, hasData], (isDataFetching, isDataFetchSuccessful, dataExists) => {
    return !isDataFetching && isDataFetchSuccessful && dataExists;
  });
  return [isOpen, handleClose];
}